import { useSx } from "dripsy";
import AnimatedPressable from "./animated-pressable";
import * as React from "react";

import CloseIcon from "./icons/close-icon";

function ModalCloseButton({ onPress }: { onPress: () => void }) {
  const sx = useSx();

  return (
    <AnimatedPressable
      style={sx({
        borderRadius: 100,
        width: 36,
        height: 36,
        alignItems: "center",
        backgroundColor: "orange",
        justifyContent: "center",
        flexDirection: "row",
      })}
      onPress={onPress}
      animate={React.useMemo(
        () =>
          ({ hovered, pressed }) => {
            return {
              backgroundColor: hovered || pressed ? "rgba(0,0,0,0.1)" : "rgba(0,0,0,0.0)",
            };
          },
        []
      )}
    >
      <CloseIcon size={15} color="$text" />
    </AnimatedPressable>
  );
}
export default ModalCloseButton;
